import { render, staticRenderFns } from "./FormComunicado.vue?vue&type=template&id=8724d8b4"
import script from "./FormComunicado.vue?vue&type=script&lang=js"
export * from "./FormComunicado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports